import { render, staticRenderFns } from "./ManageCertResetFormGroup.vue?vue&type=template&id=e57532c8&scoped=true&"
import script from "./ManageCertResetFormGroup.vue?vue&type=script&lang=js&"
export * from "./ManageCertResetFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./ManageCertResetFormGroup.vue?vue&type=style&index=0&id=e57532c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57532c8",
  null
  
)

/* custom blocks */
import block0 from "@/locales/pages/manage-cert/components/ManageCertProfessionalFormGroup.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpages%5Cmanage-cert%5Ccomponents%5CManageCertResetFormGroup.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports